module.exports = __webpack_public_path__ + "static/media/krx-tutorial-02.62720f0e.jpg";